import React, { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import { instance } from "../Controller/Common";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const Verification = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("verification_token");
  const token_forMobilenumberChange = params.get(
    "verificationMobilenumber_token"
  );
  const navigate = useNavigate();

  const [isBackdropOpen, setBackdropOpen] = useState(true);

  const handleClose = () => {
    setBackdropOpen(false);
  };

  const VerifyToken = async () => {
    try {
      const response = await instance.post(
        `/6D/auth/verify-new-token?token=${token}`,
        {}
      );
      if (response.status === 200) {
        navigate("/signin");
        window.location.reload();
      }
    } catch (error) {
      console.log("error");
    }
  };

  const VerifyTokenmobile = async () => {
    try {
      const response = await instance.post(
        `/6D/auth/verify-new-tokenforMobile?token=${token_forMobilenumberChange}`,
        {}
      );
      if (response.status === 200) {
        navigate("/signin");
        window.location.reload();
      }
    } catch (error) {
      console.log("error");
    }
  };
  React.useEffect(() => {
    if (token) {
      VerifyToken();
    } else if (token_forMobilenumberChange) {
      VerifyTokenmobile();
    }
  }, [token, token_forMobilenumberChange]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isBackdropOpen}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Verification;
